import { ShipmentsTable } from "@/features/shipments/shipments-table";
import {
  useCenterScopeNotApplicable,
  useAllCarrierOptions,
} from "@/contexts/carrier-scope-context";

export function ShipmentsPage() {
  // Shipments are carrier-scoped (Shipment.carrierId), not dispatch-center
  // scoped — the booking sits at a center, but a shipment is one carrier's
  // physical leg. Disable the center picker while this screen is mounted.
  useCenterScopeNotApplicable();
  useAllCarrierOptions();

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Shipments</h1>
      </div>
      <ShipmentsTable />
    </div>
  );
}
